import { Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useMemo, useCallback } from "react";
import { EmployeeSalaryInfoSchema } from "../../config/forms/employeeFormConfig";

const EmployeeSalaryInfoForm = ({
  textFieldStyles,
  errors,
  touchedFields,
  isSubmitted,
  register,
  watch,
  setCurrentSchema,
}) => {
  const basic = watch("basic");
  const hra = watch("hra");
  const otherAllowances = watch("other_allowances");
  const employeePf = watch("employee_pf");
  const professionalTax = watch("professional_tax");

  const grossPay = useMemo(() => (Number(basic) || 0) + (Number(hra) || 0) + (Number(otherAllowances) || 0), [basic, hra, otherAllowances]);
  const netPay = useMemo(() => grossPay - (Number(employeePf) || 0) - (Number(professionalTax) || 0), [grossPay, employeePf, professionalTax]);

  useEffect(() => {
    setCurrentSchema(EmployeeSalaryInfoSchema);
  }, []);

  const shouldShowError = useCallback((fieldName) => !!errors[fieldName] && (touchedFields[fieldName] || isSubmitted), [errors, touchedFields, isSubmitted]);

  const fields = useMemo(() => [
    { name: "basic", label: "Basic Salary (₹)", type: "input" },
    { name: "hra", label: "HRA (₹)", type: "input" },
    { name: "other_allowances", label: "Other Allowances (₹)", type: "input" },
    { name: "gross_pay", label: "Gross Pay (₹)", type: "calculated", value: grossPay },
    { name: "employee_pf", label: "Employee PF (₹)", type: "input" },
    { name: "professional_tax", label: "Professional Tax (₹)", type: "input" },
    { name: "net_pay", label: "Net Pay (₹)", type: "calculated", value: netPay },
    { name: "employer_pf", label: "Employer PF (₹)", type: "input" },
  ], [grossPay, netPay]);

  const numberInputProps = useMemo(() => ({
    ...textFieldStyles.input,
    inputProps: { min: 0, max: 10000000, step: "0.01" },
    sx: { "& input[type=number]": { MozAppearance: "textfield" }, "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 } },
  }), [textFieldStyles]);

  return (
    <Grid container spacing={2} sx={{ padding: { xs: "2% 4%", sm: "2% 8%" } }}>
      <Grid item xs={12}><Typography variant="h6" color="#DFA828" sx={{ fontWeight: 600, mb: 2 }}>Salary Information</Typography></Grid>
      {fields.map((field) => (
        <Grid item xs={12} sm={6} key={field.name}>
          <TextField
            {...(field.type === "input" ? register(field.name, { valueAsNumber: true }) : { value: field.value || 0 })}
            error={shouldShowError(field.name)}
            helperText={shouldShowError(field.name) ? errors[field.name]?.message : ""}
            label={field.label}
            fullWidth
            size="small"
            type="number"
            onKeyDown={field.type === "input" ? (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault() : undefined}
            InputProps={{ ...numberInputProps, readOnly: field.type === "calculated" }}
            InputLabelProps={textFieldStyles.label}
            FormHelperTextProps={textFieldStyles.helperText}
            sx={field.type === "calculated" ? { "& .MuiInputBase-input": { backgroundColor: "#f5f5f5" } } : {}}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default EmployeeSalaryInfoForm;